import { defineXray } from "../src/xray/manifest.js";
import { extractCiOps, describeMissing } from "../extractors/ci/index.js";
import { collect, build, groupBy, anchor, ignore } from "../extractors/ci/spec.js";

export default defineXray({
  id: "ci",
  label: "Runs",
  title: "Pipeline runs an agent watched or acted on — grouped by workflow rather than run id, with the last verdict the forge reported",

  consumer: "someone reconstructing what an agent knew about the state of CI",
  decision: "which workflow an agent was actually blocked on, what verdict it saw, and whether it re-ran something without checking the result",

  // MEASURED AS FORMATTING. the forge already names the workflow and the verdict; read inline it says what a session was blocked on
  tab: false,
  tabReason: "the forge already names the workflow and the verdict; read inline it says what a session was blocked on",
  feed: { domain: "ci" },
  extract: extractCiOps, collect, group: build, groupBy, anchor, ignore,
  emptyNote: "No runs work in this window",
  lineageReason: "forgeNodes in the host's traceProvenance already owns forge work reached through the shell, including CI runs, and holds the forge.* node kinds; a second projection over the same ops would double every PR in the graph",

  explainMissing: describeMissing,
});
